import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { TimelineItem, TimelineHeader, TimelineTitle, TimelineConnector, TimelineTime } from '@/components/ui/timeline';
import { ClockIcon, UserPen } from 'lucide-react';
import { EventLog } from '@/features/event/types';
import { formateTime } from '@/utils/formatTime';
import { cn } from '@/utils';
import { Label } from '@/features/label/components/label';
import { LabelGroup } from '@/features/label/types';
import { UserType } from '@/features/user';
import { convertUTCtoLocal } from '@/utils/convertUtcToLocal';

interface AssignedAdminTimelineItemProps {
  log: EventLog;
}

export function AssignedAdminTimelineItem({ log: { user, logText, inserted } }: AssignedAdminTimelineItemProps) {
  const data = JSON.parse(logText ?? '{}');
  const createdAtTime = formateTime(convertUTCtoLocal(inserted));

  return (
    <TimelineItem>
      <TimelineConnector className="bg-gray-medium/20" />
      <TimelineHeader>
        <UserPen className={'-translate-x-2 flex items-center rounded-md gap-x-2 bg-sky-500 w-8 h-8 p-2 text-white'} />

        <TimelineTitle>
          <div className="flex gap-x-2 items-center">
            <Avatar className="h-8 w-8 text-sm">
              <AvatarFallback className={cn('font-semibold bg-gray-medium text-white', user?.userType === UserType.ORGANIZER ? 'bg-brand-medium text-brand' : 'bg-brand')}>{user?.username?.substring(0, 2)?.toUpperCase() ?? 'U'}</AvatarFallback>
            </Avatar>
            {user?.username ?? <Label name="deleted_user" groupName={LabelGroup.GLOBAL} />}
            <Label name="changed_assigned_admin_from" groupName={LabelGroup.MANAGER_EVENT_HANDLING} />
            {data?.Old ?? '-'}
            <Label name="to" groupName={LabelGroup.MANAGER_EVENT_HANDLING} />
            {data?.New ?? '-'}
          </div>
        </TimelineTitle>

        <TimelineTime className="translate-x-24 md:-translate-x-20 flex items-center gap-x-2">
          <ClockIcon className="w-4 h-4" />
          {createdAtTime}
        </TimelineTime>
      </TimelineHeader>
    </TimelineItem>
  );
}
